import { ActionIcon, Stack, Tooltip } from "@mantine/core";
import PopOver from "../../../../../components/View/PopOver";
import { IconDotsVertical } from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import DuplicateRessource from "../../../../../components/View/DuplicateRessource";
import { copyWorkflow, deleteWorkflow } from "../../../../../api/WorkflowAPI";
import ItemDeleter from "../../../../../components/TableComponents/ItemDeleter";
import ArchiveWorkflow from "./ArchiveWorkflow";
import UnarchiveWorkflow from "./UnarchiveWorkflow";
import CopyToUser from "../../../../../components/View/CopyToUser";

const WorkflowActions = ({ apiRef, current, onFinish }) => {
  const lang = useLanguage((s) => s.language);
  const handleFinish = (closeMenu) => {
    closeMenu?.();

    setTimeout(() => {
      onFinish?.();
    }, 100);
  };

  return (
    <>
      <PopOver
        opener={(handleOpen, ref) => (
          <Tooltip label={lang.table.more_actions}>
            <ActionIcon
              variant="subtle"
              ref={ref}
              color="primary"
              onClick={handleOpen}
            >
              <IconDotsVertical size={18} />
            </ActionIcon>
          </Tooltip>
        )}
        popoverChildren={(handleClose) => (
          <Stack gap={0}>
            <CopyToUser
              current={current}
              onFinish={() => handleClose()}
              closeMenu={handleClose}
              handler={copyWorkflow}
              isWorkflow
            />

            <DuplicateRessource
              current={current}
              onFinish={() => handleFinish(handleClose)}
              closeMenu={() => {}}
              handler={copyWorkflow}
              responseField={"workflow_id"}
            />
            {current.archived ? (
              <UnarchiveWorkflow
                current={current}
                onFinish={handleFinish}
                disabled={!current.write_permission}
              />
            ) : (
              <ArchiveWorkflow
                current={current}
                onFinish={handleFinish}
                disabled={!current.write_permission}
              />
            )}
            <ItemDeleter
              title_bold={`${current.name} #${current.id}`}
              handleDelete={deleteWorkflow}
              deletedMessage={lang.workflows.delete_success}
              id={current.id}
              disabled={
                current.programmed ||
                (!current?.delete_permission &&
                  !current?.permission?.delete_permission)
              }
              disabledMessage={lang.workflows.cant_delete_workflow_programmed}
              apiRef={apiRef}
              isButton={true}
              onFinish={() => handleFinish(handleClose)}
            />
          </Stack>
        )}
        anchorOrigin={{ horizontal: "left", vertical: "center" }}
        transformOrigin={{ horizontal: "right", vertical: "center" }}
        sx={{ zIndex: "200 !important" }}
      />
    </>
  );
};

export default WorkflowActions;
